module.exports = __webpack_public_path__ + "media/MRI9A.2d7c10bb.mp3";